import React from 'react'
import { observer } from 'mobx-react'

import { Link, withRouter, useLocation } from 'react-router-dom'
import { Alert, FormGroup, FormFeedback, Input, Button, Label } from 'reactstrap'
import { Form, Field } from 'react-final-form'
import { FORM_ERROR } from 'final-form'
import { Loading } from '../../components'
import { AuthPage } from './AuthPage'

import { useStores } from '../../stores/RootStore'
import './Reset.css'

const debug = require('debug')('sd:ResetPassword1')

const _ResetPassword1 = (props) => {
  const { stores } = useStores()
  const { auth } = stores
  const { emailForLogin, cognitoUser } = auth | {}
  const { username } = cognitoUser || {}
  const search = useLocation().search
  const email = search && decodeURIComponent(new URLSearchParams(search).get('email'))
  return (
    <AuthPage
      headerSubtitle={
        <p className='d-flex justify-content-center align-items-baseline'>
          Back to <Button className='pl-1' color='link' to='/login' tag={Link}>Login</Button>
        </p>
      }
      form={
        <Form
          initialValues={{
            emailOrUsername: (emailForLogin || username || email || '')
          }}
          onSubmit={async values => {
            const { emailOrUsername } = values
            const trimmedEmailOrUsername = emailOrUsername.trim()
            try {
              await auth.forgotPassword(trimmedEmailOrUsername)
            } catch (err) {
              debug({ err })
              if (err.message === 'Username/client id combination not found.') {
                return { [FORM_ERROR]: 'No such user. Please check that your email or username is correct.' }
              }
              return { [FORM_ERROR]: err.message }
            }
          }}
          render={state => {
            debug('FinalForm.render(state)', state)
            const { handleSubmit, submitError, hasValidationErrors, submitting } = state
            return (
              <form className='auth-form' id='forgot-pass-form' onSubmit={handleSubmit}>

                <FormGroup>
                  <div className='form-label-group'>
                    <Field
                      name='emailOrUsername'
                      validate={emailOrUsername => {
                        if (!emailOrUsername) return 'Email or username is required'
                      }}
                    >
                      {({ input, meta }) => (
                        <>
                          <Input
                            {...input}
                            autoComplete
                            autoFocus
                            type='text'
                            id='emailOrUsername'
                            placeholder='Email or username'
                            invalid={meta.error && meta.touched && !meta.pristine}
                            onChange={(e) => {
                              input.onChange((e.target.value).toLowerCase().trim())
                            }}
                          />
                          <Label for='emailOrUsername'>Email or username</Label>
                          {meta.error && meta.touched && !meta.pristine && <FormFeedback>{meta.error}</FormFeedback>}
                        </>
                      )}
                    </Field>
                  </div>
                </FormGroup>

                <FormGroup>
                  {submitError
                    ? (
                      <Alert color='danger'>
                        {submitError}
                      </Alert>)
                    : null}
                  {submitting ? <Loading /> : null}
                  <Button type='submit' color='primary' disabled={submitting || hasValidationErrors} block>
                    Reset Password
                  </Button>
                  <Button className='pl-0 mt-2' color='link' to='/login' tag={Link}>
                    Back to Login
                  </Button>
                </FormGroup>
              </form>
            )
          }}
        />
      }
    />
  )
}

const ResetPassword1 = withRouter(observer(_ResetPassword1))

export { ResetPassword1 }

debug('loaded')
